const FixedBookingCategory = Object.freeze({
  WEDDING: 'wedding',
  SPORTING_EVENT: 'sporting_event',
  CONCERT: 'concert',
  PRE_BOOKED_TOUR: 'pre_booked_tour',
  VISITING_FAMILY_OR_FRIENDS: 'visiting_family_or_friends',
  RESTAURANT_RESERVATION: 'restaurant_reservation',
} as const);

export type FixedBookingCategory = (typeof FixedBookingCategory)[keyof typeof FixedBookingCategory];

export const allFixedBookingCategory: [FixedBookingCategory, ...FixedBookingCategory[]] = Object.values(
  FixedBookingCategory
) as [FixedBookingCategory, ...FixedBookingCategory[]];

export default FixedBookingCategory;
